<div class="rd-widget table-widget">
  <table class="widgetLeasingComparablesClass widget-large cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="dark-grey-line">
        <th scope="col" colspan="4">
          <span *ngIf="editMode" class="add-btn" (click)="addRow()">+</span>
          <widget-label [widget]="this" [fieldName]="'comparableNumber'" [align]="'left'" [color]="'white'"></widget-label>
        </th>
        <th scope="col" colspan="4"><widget-label [widget]="this" [fieldName]="'quarter'" [align]="'left'" [color]="'white'"></widget-label></th>
        <th scope="col" colspan="3"><widget-label [widget]="this" [fieldName]="'size'" [align]="'left'" [color]="'white'"></widget-label></th>
        <th scope="col" colspan="6"><widget-label [widget]="this" [fieldName]="'address'" [align]="'left'" [color]="'white'"></widget-label></th>
        <th scope="col" colspan="4"><widget-label [widget]="this" [fieldName]="'rent'" [align]="'left'" [color]="'white'"></widget-label></th>
        <th scope="col" colspan="3"><widget-label [widget]="this" [fieldName]="'condition'" [align]="'left'" [color]="'white'"></widget-label></th>
        <th scope="col" colspan="3"><widget-label [widget]="this" [fieldName]="'term'" [align]="'left'" [color]="'white'"></widget-label></th>
        <th scope="col" colspan="8"><widget-label [widget]="this" [fieldName]="'comments'" [align]="'left'" [color]="'white'"></widget-label></th>
      </tr>
    </thead>
    <tbody class="extraTbody">

      <ng-container *ngFor="let entry of widgetData.rows; let i = index">
        <tr *ngIf="!editMode" [ngClass]="{'light-grey-line': (i % 2 === 0), 'light-grey-line': (i % 2 !== 0)}">
          <td colspan="4"><widget-value [align]="'left'">{{entry.comparableNumber}}</widget-value></td>
          <td colspan="4"><widget-value [align]="'left'"><label hashtagsetvalue [widget]="this" [page]="page">{{entry.quarter}}</label></widget-value></td>
          <td colspan="3"><widget-value [align]="'left'">{{entry.size | rdLocalizedNumber:0}} {{unitOfArea}}</widget-value></td>
          <td colspan="6"><widget-value [align]="'left'"><label hashtagsetvalue [widget]="this" [page]="page">{{entry.address}}</label></widget-value></td>

          <td colspan="4">
            <widget-value *ngIf="this.displayValuesOverTimeId == 1" [align]="'left'">{{entry.rent | rdLocalizedNumber:2}} {{currency}}/{{unitOfArea}}/pa</widget-value>
            <widget-value *ngIf="this.displayValuesOverTimeId == 2" [align]="'left'">{{entry.rent | rdLocalizedNumber:2}} {{currency}}/{{unitOfArea}}/pm</widget-value>
          </td>
          <td colspan="3"><widget-value [align]="'left'"><label hashtagsetvalue [widget]="this" [page]="page">{{entry.condition}}</label></widget-value></td>
          <td colspan="3"><widget-value [align]="'left'" *ngIf="( (entry.term || '') == '0' )">n/a</widget-value><widget-value [align]="'left'" *ngIf="( (entry.term || '') != '0' )">{{entry.term}}</widget-value></td>
          <td colspan="8"><widget-value [align]="'left'"><label hashtagsetvalue [widget]="this" [page]="page">{{entry.comments}}</label></widget-value></td>
        </tr>
        <tr *ngIf="editMode" class="light-grey-line gridster-item-content">
          <td colspan="4">
            <span style="font-size: 20px; font-weight: bold;" *ngIf="editMode" class="add-btn" (click)="removeRow(entry)">-</span>
            <input style="width:83%" type="number" class="widget-input-text" [(ngModel)]="entry.comparableNumber" (ngModelChange)="setDirtyFlag(true, true)" />
          </td>
          <td colspan="4">
            <input type="text" class="widget-input-text gridster-item-content"
                   hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
                   [elType]="'text'" [page]="page"
                   [editMode]="editMode"
                   (setNewValue)="entry.quarter= $event;"
                   id="quarter{{i}}" [(ngModel)]="entry.quarter" (ngModelChange)="setDirtyFlag(true, true)" />
          </td>
          <td colspan="3">
            <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="entry.size" (valueChange)="setDirtyFlag(true, true)" [isNullable]="true" [decimals]="0" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
          </td>
          <td colspan="6">
            <input type="text" class="widget-input-text gridster-item-content"
                   hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
                   [elType]="'text'" [page]="page"
                   [editMode]="editMode"
                   (setNewValue)="entry.address= $event;"
                   id="lcaddress{{i}}" [(ngModel)]="entry.address" (ngModelChange)="setDirtyFlag(true, true)" />
          </td>
          <td colspan="4">
            <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="entry.rent" (valueChange)="setDirtyFlag(true, true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
          </td>
          <td colspan="3">
            <input type="text" class="widget-input-text gridster-item-content"
                   hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
                   [elType]="'text'" [page]="page"
                   [editMode]="editMode"
                   (setNewValue)="entry.condition= $event;"
                   id="lccondition{{i}}" [(ngModel)]="entry.condition" (ngModelChange)="setDirtyFlag(true, true)" />
          </td>
          <td colspan="3">
            <input type="text" class="widget-input-text gridster-item-content"
                   id="term{{i}}" [(ngModel)]="entry.term" (ngModelChange)="setDirtyFlag(true, true)" />
          </td>
          <td colspan="8">
            <input type="text" class="widget-input-text gridster-item-content"
                   hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
                   [elType]="'text'" [page]="page"
                   [editMode]="editMode"
                   (setNewValue)="entry.comments= $event;"
                   id="lccomments{{i}}" [(ngModel)]="entry.comments" (ngModelChange)="setDirtyFlag(true, true)" />
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
